'use strict';exports.__esModule = true;exports.calculatePriceForOneProperty = exports.calculatePaymentAmount = exports.calculatePaymentAmountWithVatForRequest = exports.calculatePaymentAmountForRequest = exports.getCouponBonus = exports.getDiscountValue = exports.getPackagePriceForOneMonth = exports.calculatePriceWithDiscount = exports.calculatePriceWithVAT = undefined;var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _clearNumber = require('./clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _beautifyNumber = require('./beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _constants = require('../constants');
var _getDecimal = require('../utils/getDecimal');var _getDecimal2 = _interopRequireDefault(_getDecimal);
var _couponsConfig = require('../containers/DiscountCouponContainer/couponsConfig');
var _packagesData = require('../packagesData');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var calcDiscountedPrice = function calcDiscountedPrice(price, discount) {return Math.floor(price * (1 - discount / 100));};
var calculatePriceWithVAT = exports.calculatePriceWithVAT = function calculatePriceWithVAT(beforeVat) {var vat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.VAT;return beforeVat + vat * beforeVat / 100;};

var calculatePriceWithDiscount = exports.calculatePriceWithDiscount = function calculatePriceWithDiscount(pack, period) {
  var price = (0, _get2.default)(pack, 'period[' + period + '].price');
  var discount = (0, _get2.default)(pack, 'period[' + period + '].discount');

  return discount ? calcDiscountedPrice(price, discount) : price;
};

var getPackagePriceForOneMonth = exports.getPackagePriceForOneMonth = function getPackagePriceForOneMonth() {var current = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};var packages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var selectedPackage = packages.find(function (_ref) {var id = _ref.id;return id === current.checked;});var
  period = current.period,alternativePeriod = current.alternativePeriod;
  var currentPeriod = (0, _get2.default)(selectedPackage, 'period.' + period) ? period : alternativePeriod;

  return calculatePriceWithDiscount(selectedPackage, currentPeriod);
};

var getDiscountValue = exports.getDiscountValue = function getDiscountValue(couponValue, currentPackage) {
  if (typeof couponValue === 'number') {return couponValue;}

  var key = 'package_id_' + currentPackage.checked + '_' + currentPackage.period;

  return couponValue[key] || 0;
};

var getCouponBonus = exports.getCouponBonus = function getCouponBonus(amount, coupon, currentPackage, packages) {
  var bonusAmount = void 0;
  var couponDescription = (0, _get2.default)(_couponsConfig.discountCouponsTypes, '[' + coupon + ']', {});var
  couponType = couponDescription.type,couponValue = couponDescription.value;

  if (couponType === _couponsConfig.couponsTypes.DISCOUNT) {
    var discount = getDiscountValue(couponValue, currentPackage);
    bonusAmount = amount * discount / 100;
  }

  if (couponType === _couponsConfig.couponsTypes.FREE) {
    bonusAmount = getPackagePriceForOneMonth(currentPackage, packages) * couponValue;
  }

  return bonusAmount;
};

var calculatePaymentAmountForRequest = exports.calculatePaymentAmountForRequest = function calculatePaymentAmountForRequest(_ref2, packages) {var checked = _ref2.checked,period = _ref2.period,alternativePeriod = _ref2.alternativePeriod;
  var selectedPackage = packages.filter(function (pack) {return pack.id === checked;})[0] || {};
  var currentPeriod = (0, _get2.default)(selectedPackage, 'period.' + period) ? period : alternativePeriod;

  var priceWithDiscount = calculatePriceWithDiscount(selectedPackage, currentPeriod);
  var isShouldCalcTotal = !!selectedPackage.properties;

  return isShouldCalcTotal ? priceWithDiscount * currentPeriod : priceWithDiscount;
};

var calculatePaymentAmountWithVatForRequest = exports.calculatePaymentAmountWithVatForRequest = function calculatePaymentAmountWithVatForRequest(_ref3, packages, coupon) {var checked = _ref3.checked,period = _ref3.period,alternativePeriod = _ref3.alternativePeriod;
  var beforeVat = calculatePaymentAmountForRequest({ checked: checked, period: period, alternativePeriod: alternativePeriod }, packages);
  var couponBonus = !!coupon ?
  getCouponBonus(beforeVat, coupon, { checked: checked, period: period, alternativePeriod: alternativePeriod }, packages) :
  0;
  var beforeVatWithBonus = beforeVat - couponBonus;

  var withVAT = calculatePriceWithVAT(beforeVatWithBonus, _constants.VAT);
  var priceGrand = (0, _getDecimal2.default)(withVAT).toString().substring(2).length > 2 ?
  parseInt(withVAT * 100, 10) / 100 : withVAT;

  var tax = withVAT - beforeVat;
  return { priceGrand: priceGrand, tax: tax, couponBonus: couponBonus };
};

var calculatePaymentAmount = exports.calculatePaymentAmount = function calculatePaymentAmount(current, packages) {
  var amount = calculatePaymentAmountForRequest(current, packages);
  return (0, _beautifyNumber2.default)((0, _clearNumber2.default)(amount));
};

var calculatePriceForOneProperty = exports.calculatePriceForOneProperty = function calculatePriceForOneProperty(pack, period) {return (
    Math.round(calculatePriceWithDiscount(pack, period) / pack.properties));};


//////////////////
// WEBPACK FOOTER
// ./src/helpers/paymentCalculation.js
// module id = 97
// module chunks = 0